var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.75,10 C8.026,10 8.25,9.7765 8.25,9.5 C8.25,9.3615 8.194,9.2365 8.103,9.146 L4.957,6 L8.103,2.854 C8.194,2.7635 8.25,2.6385 8.25,2.5 C8.25,2.2235 8.026,2 7.75,2 C7.612,2 7.487,2.056 7.396,2.1465 L7.396,2.146 L3.896,5.646 C3.8935,5.649 3.8925,5.6535 3.8895,5.6565 C3.8475,5.7005 3.8125,5.751 3.7885,5.808 C3.7635,5.8685 3.75,5.934 3.75,6 C3.75,6.066 3.7635,6.1315 3.7885,6.1915 C3.814,6.2525 3.8505,6.308 3.8965,6.354 L7.396,9.8535 C7.4865,9.944 7.6115,10 7.75,10",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PageTitle/PC\\uFF08BackLink\\uFF09",
    transform: "translate(-125.000000, -27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/common/back",
    transform: "translate(125.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-back",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "primary",
    mask: "url(#mask-back)",
    fill: "#0CA5E6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "color",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.3a35fa65e653b189e48c909e1a0b3983.svg";
export { ForwardRef as ReactComponent };